
  var _styles = {
  "search-area-fixed-container": {
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex"
  },
  "search-area-container": {
    "height": "1.41333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.37333rem",
    "marginRight": "0.42667rem",
    "marginBottom": "0.18667rem",
    "marginLeft": "0.26667rem"
  },
  "search-area-input-container": {
    "marginLeft": "0.37333rem",
    "background": "#f4f5f8",
    "borderRadius": "0.10667rem",
    "height": "0.85333rem",
    "width": "8.24rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "search-area-input": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(0,0,0)",
    "lineHeight": "0.37333rem",
    "width": "6.66667rem",
    "outline": "none"
  },
  "search-area-close": {
    "width": "0.64rem",
    "height": "0.64rem"
  },
  "search-area-search-icon": {
    "marginLeft": "0.26667rem",
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "search-area-suggest-container": {
    "marginTop": 0,
    "marginRight": "0.42667rem",
    "marginBottom": 0,
    "marginLeft": "0.42667rem",
    "height": "100%"
  },
  "search-area-not-found": {
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "search-area-not-found-image": {
    "marginTop": "2.66667rem",
    "height": "4rem",
    "width": "4rem"
  },
  "search-area-not-found-text-container": {
    "flexDirection": "row",
    "justifyContent": "center",
    "marginTop": "0.64rem"
  },
  "search-area-not-found-text-normal": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.42667rem",
    "color": "rgb(34,34,34)",
    "textAlign": "center",
    "lineHeight": "0.42667rem"
  },
  "search-area-not-found-text-blue": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.42667rem",
    "color": "rgb(0,64,153)",
    "textAlign": "center",
    "lineHeight": "0.42667rem"
  },
  "search-area-not-found-text-bottom": {
    "marginTop": "0.48rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(102,102,102)",
    "textAlign": "center",
    "lineHeight": "0.37333rem"
  },
  "bottom-box": {
    "height": "1.33333rem"
  }
};



  module.exports = _styles;
  